  (() => {
    var sectionId = document.currentScript.dataset.sectionId;
    var sectionSelector = '#shopify-section-' + sectionId;
    var MOBILE_MAX_WIDTH = 950;

    function isMobileShopTheLook() {
      return window.matchMedia('(max-width: ' + MOBILE_MAX_WIDTH + 'px)').matches;
    }

    function updateSwiperNoSwiping(swiper) {
      if (!swiper) return;

      var mobile = isMobileShopTheLook();
      swiper.params.noSwiping = mobile;
      swiper.params.noSwipingSelector = mobile
        ? '.ec-shop-the-look__products-zone, .ec-shop-the-look__products-zone *'
        : '';
    }

    function hasMobileProductCarousel(slide) {
      return !!(slide && slide.querySelector('.ec-shop-the-look__products-track'));
    }

    function getProductIndexFromScroll(slide) {
      var track = slide.querySelector('.ec-shop-the-look__products-track');
      if (!track) return -1;

      var products = Array.from(track.querySelectorAll('.ec-shop-the-look__product'));
      if (!products.length) return -1;

      var scrollLeft = track.scrollLeft;
      var closestIndex = 0;
      var minDistance = Infinity;

      products.forEach(function(product, index) {
        var distance = Math.abs(product.offsetLeft - scrollLeft);
        if (distance < minDistance) {
          minDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    function scrollToProductIndex(slide, productIndex, behavior) {
      var track = slide.querySelector('.ec-shop-the-look__products-track');
      if (!track) return false;

      var products = track.querySelectorAll('.ec-shop-the-look__product');
      var product = products[productIndex];
      if (!product) return false;

      track.scrollTo({
        left: product.offsetLeft,
        behavior: behavior || 'smooth',
      });

      return true;
    }

    function bindProductTrackScroll(slide, sectionRoot) {
      var track = slide.querySelector('.ec-shop-the-look__products-track');
      if (!track || track.dataset.scrollBound === 'true') return;

      track.dataset.scrollBound = 'true';

      var scrollRaf = null;
      track.addEventListener(
        'scroll',
        function() {
          if (scrollRaf) window.cancelAnimationFrame(scrollRaf);
          scrollRaf = window.requestAnimationFrame(function() {
            renderProductPagination(sectionRoot);
          });
        },
        { passive: true }
      );
    }

    function initMobileProductTracks(sectionRoot) {
      if (!isMobileShopTheLook()) return;

      sectionRoot.querySelectorAll('.ec-shop-the-look__item').forEach(function(slide) {
        var container = slide.querySelector('.ec-shop-the-look-container');
        if (!container) return;

        var products = Array.from(slide.querySelectorAll('.ec-shop-the-look__product'));
        if (!products.length) return;

        var productIndexes = getSlideProductIndexes(slide);

        slide.classList.remove('has-mobile-product-carousel', 'is-single-product', 'has-single-mobile-product', 'has-no-mobile-products');

        setSlideEmptyProductsHidden(slide, productIndexes);

        if (!productIndexes.length) {
          slide.classList.add('has-no-mobile-products');
          products.forEach(function(product) {
            product.classList.add('hidden');
            product.classList.remove('visible');
          });
          return;
        }

        if (productIndexes.length <= 1) {
          slide.classList.add('has-single-mobile-product');

          var pagination = slide.querySelector('.ec-shop-the-look__pagination');
          if (pagination) {
            pagination.style.display = 'none';
          }

          products.forEach(function(product, index) {
            product.classList.remove('is-entering-next', 'is-entering-prev');

            if (productIndexes.indexOf(index) > -1) {
              product.classList.add('visible');
              product.classList.remove('hidden', 'ec-shop-the-look__product--empty');
            }
          });

          return;
        }

        var zone = document.createElement('div');
        zone.className = 'ec-shop-the-look__products-zone';
        var track = document.createElement('div');
        track.className = 'ec-shop-the-look__products-track';

        productIndexes.forEach(function(index) {
          var product = products[index];
          if (!product) return;

          product.classList.remove('hidden', 'visible', 'is-entering-next', 'is-entering-prev');
          track.appendChild(product);
        });

        zone.appendChild(track);

        var pagination = slide.querySelector('.ec-shop-the-look__pagination');
        if (pagination) {
          zone.appendChild(pagination);
        }

        var hotspot = slide.querySelector('.ec-image-hotspot');
        if (hotspot) {
          container.insertBefore(zone, hotspot);
        } else {
          container.appendChild(zone);
        }

        slide.classList.add('has-mobile-product-carousel');

        bindProductTrackScroll(slide, sectionRoot);

        window.requestAnimationFrame(function() {
          scrollToProductIndex(slide, productIndexes[0], 'auto');
          renderProductPagination(sectionRoot);
        });
      });
    }

    function destroyMobileProductTracks(sectionRoot) {
      sectionRoot.querySelectorAll('.ec-shop-the-look__item').forEach(function(slide) {
        var zone = slide.querySelector('.ec-shop-the-look__products-zone');
        var track = slide.querySelector('.ec-shop-the-look__products-track');

        if (zone && track) {
          var container = slide.querySelector('.ec-shop-the-look-container');
          var productsColumn = slide.querySelector('.ec-shop-the-look__products-side') || container;
          var productNav = slide.querySelector('.ec-shop-the-look__product-nav');
          var pagination = zone.querySelector('.ec-shop-the-look__pagination');
          var trackProducts = Array.from(track.querySelectorAll('.ec-shop-the-look__product'));

          trackProducts.forEach(function(product) {
            if (productNav) {
              productsColumn.insertBefore(product, productNav);
            } else if (productsColumn) {
              productsColumn.appendChild(product);
            }

            product.classList.remove('is-active-slide');
          });

          if (pagination && productsColumn) {
            productsColumn.appendChild(pagination);
          }

          zone.remove();

          var productIndexes = getSlideProductIndexes(slide);
          var allProducts = Array.from(slide.querySelectorAll('.ec-shop-the-look__product'));

          allProducts.forEach(function(product, index) {
            if (index === productIndexes[0]) {
              product.classList.add('visible');
              product.classList.remove('hidden');
            } else {
              product.classList.add('hidden');
              product.classList.remove('visible');
            }
          });
        }

        var pagination = slide.querySelector('.ec-shop-the-look__pagination');
        if (pagination) {
          pagination.style.display = '';
        }

        slide.querySelectorAll('.ec-shop-the-look__product--empty').forEach(function(product) {
          product.classList.remove('ec-shop-the-look__product--empty');
        });

        slide.classList.remove(
          'has-mobile-product-carousel',
          'is-single-product',
          'has-single-mobile-product',
          'has-no-mobile-products'
        );
      });
    }

    function syncMobileProductCarousel(sectionRoot) {
      destroyMobileProductTracks(sectionRoot);

      if (isMobileShopTheLook()) {
        initMobileProductTracks(sectionRoot);
      }
    }

    function getActiveSlide(sectionRoot) {
      return (
        sectionRoot.querySelector('.ec-shop-the-look .swiper-slide-active') ||
        sectionRoot.querySelector('.ec-shop-the-look__item')
      );
    }

    function isValidSlideProduct(product) {
      if (!product) return false;

      var name = product.querySelector('.ec-shop-the-look__product-name');
      var nameText = name ? (name.textContent || '').trim() : '';
      var button = product.querySelector('.ec-shop-the-look__product-button');
      var href = button ? (button.getAttribute('href') || '').trim() : '';
      var image = product.querySelector('.ec-shop-the-look__product-image');
      var imageSrc = image ? (image.getAttribute('src') || '').trim() : '';

      if (imageSrc) {
        var lowerSrc = imageSrc.toLowerCase();
        if (lowerSrc.indexOf('liquid error') !== -1 || lowerSrc.indexOf('invalid url') !== -1) {
          imageSrc = '';
        }
      }

      var hasValidHref = href.indexOf('/products/') !== -1;
      var hasValidImage = imageSrc.indexOf('/cdn/') !== -1;

      return !!(nameText || hasValidHref || hasValidImage);
    }

    function getSlideProductIndexes(slide) {
      if (!slide) return [];

      var products = Array.from(slide.querySelectorAll('.ec-shop-the-look__product'));
      var indexes = [];

      products.forEach(function(product, index) {
        if (isValidSlideProduct(product)) {
          indexes.push(index);
        }
      });

      return indexes;
    }

    function setSlideEmptyProductsHidden(slide, productIndexes) {
      var products = Array.from(slide.querySelectorAll('.ec-shop-the-look__product'));

      products.forEach(function(product, index) {
        if (productIndexes.indexOf(index) === -1) {
          product.classList.add('hidden', 'ec-shop-the-look__product--empty');
          product.classList.remove('visible');
        } else {
          product.classList.remove('ec-shop-the-look__product--empty');
        }
      });
    }

    function getVisibleProductIndex(slide) {
      if (!slide) return -1;

      if (hasMobileProductCarousel(slide)) {
        return getProductIndexFromScroll(slide);
      }

      var products = Array.from(slide.querySelectorAll('.ec-shop-the-look__product'));
      return products.findIndex(function(product) { return product.classList.contains('visible'); });
    }

    function setVisibleProduct(slide, productIndex) {
      if (!slide) return;

      if (hasMobileProductCarousel(slide)) {
        scrollToProductIndex(slide, productIndex, 'smooth');
        return;
      }

      var products = slide.querySelectorAll('.ec-shop-the-look__product');
      if (!products.length) return;

      var direction = slide.dataset.productDirection || 'next';

      var validIndexes = getSlideProductIndexes(slide);
      var safeIndex = validIndexes.indexOf(productIndex) > -1 ? productIndex : validIndexes[0];
      if (typeof safeIndex !== 'number') safeIndex = 0;

      safeIndex = Math.max(0, Math.min(safeIndex, products.length - 1));

      products.forEach(function(product) {
        product.classList.remove('visible');
        product.classList.add('hidden');
        product.classList.remove('is-entering-next', 'is-entering-prev');
      });

      if (products[safeIndex]) {
        products[safeIndex].classList.remove('hidden');
        products[safeIndex].classList.add('visible');
        products[safeIndex].classList.add(direction === 'prev' ? 'is-entering-prev' : 'is-entering-next');
      }
    }

    function getActiveSlidePagination(sectionRoot) {
      var activeSlide = getActiveSlide(sectionRoot);
      if (!activeSlide) return sectionRoot.querySelector('.ec-shop-the-look__pagination');
      return activeSlide.querySelector('.ec-shop-the-look__pagination');
    }

    function renderProductPagination(sectionRoot) {
      var activeSlide = getActiveSlide(sectionRoot);
      if (!activeSlide) return;

      var paginationEl = getActiveSlidePagination(sectionRoot);
      if (!paginationEl) return;

      var productIndexes = getSlideProductIndexes(activeSlide);
      var currentIndex = getVisibleProductIndex(activeSlide);
      if (currentIndex < 0 && productIndexes.length) {
        currentIndex = productIndexes[0];
      }

      paginationEl.innerHTML = '';

      if (productIndexes.length <= 1) {
        paginationEl.style.display = 'none';
        return;
      }

      paginationEl.style.display = 'flex';

      productIndexes.forEach(function(productIndex, bulletPos) {
        var bullet = document.createElement('span');
        bullet.className = 'swiper-pagination-bullet';
        bullet.setAttribute('tabindex', '0');
        bullet.setAttribute('role', 'button');
        bullet.setAttribute('aria-label', 'Ir para produto ' + (bulletPos + 1));

        if (productIndex === currentIndex) {
          bullet.classList.add('swiper-pagination-bullet-active');
          bullet.setAttribute('aria-current', 'true');
        }

        bullet.addEventListener('click', function() {
          var currentVisibleIndex = getVisibleProductIndex(activeSlide);
          activeSlide.dataset.productDirection = productIndex < currentVisibleIndex ? 'prev' : 'next';
          setVisibleProduct(activeSlide, productIndex);
          if (!hasMobileProductCarousel(activeSlide)) {
            placeCarouselPagination(sectionRoot);
          }
          window.setTimeout(function() {
            renderProductPagination(sectionRoot);
          }, hasMobileProductCarousel(activeSlide) ? 320 : 0);
        });

        paginationEl.appendChild(bullet);
      });
    }

    function initActiveSlideProduct(sectionRoot) {
      var activeSlide = getActiveSlide(sectionRoot);
      if (!activeSlide) return;

      var productIndexes = getSlideProductIndexes(activeSlide);
      if (!productIndexes.length) return;

      var currentIndex = getVisibleProductIndex(activeSlide);
      if (productIndexes.indexOf(currentIndex) === -1) {
        setVisibleProduct(activeSlide, productIndexes[0]);
      }

      if (hasMobileProductCarousel(activeSlide)) {
        renderProductPagination(sectionRoot);
      }
    }

    function changeProductFromArrow(sectionRoot, step) {
      var activeSlide = getActiveSlide(sectionRoot);
      if (!activeSlide) return;

      activeSlide.dataset.productDirection = step < 0 ? 'prev' : 'next';

      var productIndexes = getSlideProductIndexes(activeSlide);
      if (productIndexes.length <= 1) return;

      var currentIndex = getVisibleProductIndex(activeSlide);
      if (currentIndex < 0) currentIndex = productIndexes[0];

      var currentPos = productIndexes.indexOf(currentIndex);
      if (currentPos < 0) currentPos = 0;

      var nextPos = (currentPos + step + productIndexes.length) % productIndexes.length;
      var nextProductIndex = productIndexes[nextPos];

      setVisibleProduct(activeSlide, nextProductIndex);

      if (!hasMobileProductCarousel(activeSlide)) {
        placeCarouselPagination(sectionRoot);
      }

      window.setTimeout(function() {
        renderProductPagination(sectionRoot);
        updateProductArrowsState(sectionRoot);
      }, hasMobileProductCarousel(activeSlide) ? 320 : 0);
    }

    function updateProductArrowsState(sectionRoot) {
      if (isMobileShopTheLook()) return;

      var activeSlide = getActiveSlide(sectionRoot);
      if (!activeSlide) return;

      var productNav = activeSlide.querySelector('.ec-shop-the-look__product-nav');
      if (!productNav) return;

      var nextArrow = productNav.querySelector('.swiper-button-next');
      var prevArrow = productNav.querySelector('.swiper-button-prev');
      if (!nextArrow || !prevArrow) return;

      var productIndexes = getSlideProductIndexes(activeSlide);
      var disableArrows = productIndexes.length <= 1;

      productNav.style.display = disableArrows ? 'none' : '';

      [prevArrow, nextArrow].forEach(function(arrow) {
        arrow.classList.toggle('swiper-button-disabled', disableArrows);
        arrow.setAttribute('aria-disabled', disableArrows ? 'true' : 'false');
        arrow.style.pointerEvents = disableArrows ? 'none' : '';
      });
    }

    function setProductNavSwitchingState(sectionRoot, isSwitching) {
      var activeSlide = getActiveSlide(sectionRoot);
      if (!activeSlide) return;

      var productNav = activeSlide.querySelector('.ec-shop-the-look__product-nav');
      if (!productNav) return;
      productNav.classList.toggle('is-switching-look', !!isSwitching);
    }

    function placeCarouselPagination(sectionRoot) {
      if (isMobileShopTheLook()) return;

      var activeSlide =
        sectionRoot.querySelector('.ec-shop-the-look .swiper-slide-active') ||
        sectionRoot.querySelector('.ec-shop-the-look__item');
      if (!activeSlide) return;

      var paginationEl = activeSlide.querySelector('.ec-shop-the-look__pagination');
      if (!paginationEl) return;

      var productsSide = activeSlide.querySelector('.ec-shop-the-look__products-side');
      if (!productsSide) return;

      if (paginationEl.parentElement !== productsSide) {
        productsSide.appendChild(paginationEl);
      }
    }

    function bindProductArrows(sectionRoot) {
      if (isMobileShopTheLook()) return;

      var activeSlide = getActiveSlide(sectionRoot);
      if (!activeSlide) return;

      var productNav = activeSlide.querySelector('.ec-shop-the-look__product-nav');
      if (!productNav || productNav.dataset.productArrowsBound === 'true') return;

      var nextArrow = productNav.querySelector('.swiper-button-next');
      var prevArrow = productNav.querySelector('.swiper-button-prev');
      if (!nextArrow || !prevArrow) return;

      productNav.dataset.productArrowsBound = 'true';

      prevArrow.addEventListener('click', function(event) {
        event.preventDefault();
        changeProductFromArrow(sectionRoot, -1);
      });

      nextArrow.addEventListener('click', function(event) {
        event.preventDefault();
        changeProductFromArrow(sectionRoot, 1);
      });

      updateProductArrowsState(sectionRoot);
    }

    function bindModelArrows(sectionRoot, swiper) {
      if (!swiper) return;

      var prevButtons = sectionRoot.querySelectorAll('.ec-shop-the-look__model-nav--prev');
      var nextButtons = sectionRoot.querySelectorAll('.ec-shop-the-look__model-nav--next');

      prevButtons.forEach(function(button) {
        if (button.dataset.modelArrowBound === 'true') return;
        button.dataset.modelArrowBound = 'true';
        button.addEventListener('click', function(event) {
          event.preventDefault();
          swiper.slidePrev();
        });
      });

      nextButtons.forEach(function(button) {
        if (button.dataset.modelArrowBound === 'true') return;
        button.dataset.modelArrowBound = 'true';
        button.addEventListener('click', function(event) {
          event.preventDefault();
          swiper.slideNext();
        });
      });
    }

    function getSelectedVariantId(productCard) {
      if (!productCard) return null;

      var variantsRoot = productCard.querySelector('.ec-shop-the-look__mobile-variants');
      if (!variantsRoot) return null;

      var variantsScript = variantsRoot.querySelector('[data-shop-the-look-variants]');
      if (!variantsScript) return null;

      var variants = [];
      try {
        variants = JSON.parse(variantsScript.textContent || '[]');
      } catch (error) {
        return null;
      }

      if (!Array.isArray(variants) || !variants.length) return null;

      var selectedValues = Array.from(
        variantsRoot.querySelectorAll('.product-form__product-variants input[type="radio"]:checked')
      )
        .map(function(input) {
          return (input.value || '').trim();
        })
        .filter(function(value) {
          return value !== '';
        });

      var exactMatch = variants.find(function(variant) {
        if (!variant || !Array.isArray(variant.options)) return false;

        return selectedValues.every(function(selectedValue, index) {
          if (!selectedValue) return true;
          return variant.options[index] === selectedValue;
        });
      });

      if (exactMatch && exactMatch.available) {
        return exactMatch.id;
      }

      var firstOptionValue = selectedValues[0];
      if (firstOptionValue) {
        var fallbackWithColor = variants.find(function(variant) {
          return variant.available && Array.isArray(variant.options) && variant.options[0] === firstOptionValue;
        });

        if (fallbackWithColor) {
          return fallbackWithColor.id;
        }
      }

      var firstAvailable = variants.find(function(variant) {
        return !!variant.available;
      });

      return firstAvailable ? firstAvailable.id : (exactMatch ? exactMatch.id : null);
    }

    function getBuyVariantId(productCard, button) {
      return getSelectedVariantId(productCard) || button.getAttribute('data-default-variant-id');
    }

    function updateHeaderCartCount(itemCount) {
      var cartLink = document.querySelector('#cart-icon-bubble');
      if (!cartLink) return;

      cartLink.classList.toggle('cart-empty', itemCount === 0);

      var desktopText = cartLink.querySelector('.ec-cart-link__text--desktop');
      if (desktopText) {
        desktopText.textContent = desktopText.textContent.replace(/\(\d+\)/, '(' + itemCount + ')');
      }

      var tabletText = cartLink.querySelector('.ec-cart-link__text--tablet');
      if (tabletText) {
        tabletText.textContent = tabletText.textContent.replace(/\(\d+\)/, '(' + itemCount + ')');
      }

      var bubble = cartLink.querySelector('.cart-count-bubble');
      if (itemCount > 0) {
        if (!bubble) {
          bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          bubble.innerHTML =
            '<span aria-hidden="true"></span>' +
            '<span class="visually-hidden">' + itemCount + '</span>';
          cartLink.appendChild(bubble);
        }

        var visibleCount = bubble.querySelector('[aria-hidden="true"]');
        if (visibleCount) {
          visibleCount.textContent = itemCount < 100 ? String(itemCount) : '';
        }
      } else if (bubble) {
        bubble.remove();
      }

      var ariaLabel = cartLink.getAttribute('aria-label');
      if (ariaLabel && ariaLabel.indexOf('(') !== -1) {
        cartLink.setAttribute('aria-label', ariaLabel.replace(/\(\d+\)/, '(' + itemCount + ')'));
      }
    }

    function refreshCartDrawerFromSections(cartElement, sections) {
      if (!cartElement || !sections || !sections['cart-drawer']) return false;

      var cartDrawerContainer = document.querySelector('#CartDrawer');
      if (!cartDrawerContainer || typeof cartElement.getSectionInnerHTML !== 'function') return false;

      try {
        var drawerMarkup = cartElement.getSectionInnerHTML(sections['cart-drawer'], '#CartDrawer');
        if (!drawerMarkup) return false;

        cartDrawerContainer.innerHTML = drawerMarkup;
      } catch (parseError) {
        console.error('Error parsing cart drawer section', parseError);
        return false;
      }

      var drawerInner = cartElement.querySelector('.drawer__inner');
      if (drawerInner && drawerInner.classList.contains('is-empty')) {
        drawerInner.classList.remove('is-empty');
      }

      var overlay = cartElement.querySelector('#CartDrawer-Overlay');
      if (overlay) {
        overlay.addEventListener('click', cartElement.close.bind(cartElement));
      }

      if (typeof cartElement.setRelatedProducts === 'function') {
        cartElement.setRelatedProducts();
      }

      return true;
    }

    async function syncCartUi(cartElement, sections) {
      if (!cartElement) return;

      if (cartElement.classList.contains('is-empty')) {
        cartElement.classList.remove('is-empty');
      }

      var drawerUpdated = false;

      if (sections && cartElement.tagName === 'CART-DRAWER') {
        drawerUpdated = refreshCartDrawerFromSections(cartElement, sections);
      } else if (sections && typeof cartElement.renderContents === 'function') {
        cartElement.renderContents({ sections: sections });
        drawerUpdated = true;
      }

      if (!drawerUpdated && cartElement.tagName === 'CART-DRAWER') {
        try {
          var sectionsResponse = await fetch(window.location.pathname + '?sections=cart-drawer');
          if (sectionsResponse.ok) {
            var sectionsData = await sectionsResponse.json();
            drawerUpdated = refreshCartDrawerFromSections(cartElement, sectionsData);
          }
        } catch (sectionsError) {
          console.error('Error fetching cart drawer section', sectionsError);
        }
      }

      try {
        var cartResponse = await fetch('/cart.js');
        if (cartResponse.ok) {
          var cart = await cartResponse.json();
          updateHeaderCartCount(cart.item_count);
        }
      } catch (cartError) {
        console.error('Error fetching cart count', cartError);
      }

      if (cartElement.tagName === 'CART-DRAWER' && typeof cartElement.open === 'function') {
        cartElement.open(document.activeElement);
      }
    }

    async function addProductToCart(variantId) {
      if (!variantId) return;

      const parsedVariantId = Number(variantId);
      if (Number.isNaN(parsedVariantId)) return;

      const cartElement = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
      const formData = new FormData();

      formData.append('id', parsedVariantId);
      formData.append('quantity', '1');

      if (cartElement && typeof cartElement.getSectionsToRender === 'function') {
        formData.append(
          'sections',
          cartElement
            .getSectionsToRender()
            .map(function(section) {
              return section.id;
            })
            .join(',')
        );
        formData.append('sections_url', window.location.pathname);
      }

      try {
        const response = await fetch(cartAddUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData,
        });

        if (!response.ok) return;

        const data = await response.json();

        if (data.status) {
          console.error('Error adding product to cart', data.description || data.message);
          return;
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'shop-the-look',
            productVariantId: String(parsedVariantId),
            cartData: data,
          });
        }

        if (!cartElement) {
          if (window.routes && window.routes.cart_url) {
            window.location.href = window.routes.cart_url;
          }
          return;
        }

        await syncCartUi(cartElement, data.sections);
      } catch (error) {
        console.error('Error adding product to cart', error);
      }
    }

    function ensureAvailableVariantSelection(variantSelects) {
      var fieldsets = Array.from(variantSelects.querySelectorAll('.product-form__input'));
      var didChange = false;

      fieldsets.forEach(function(fieldset) {
        var inputs = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
        if (!inputs.length) return;

        var checkedInput = fieldset.querySelector('input[type="radio"]:checked');
        if (!checkedInput || checkedInput.classList.contains('disabled')) {
          var firstAvailable = inputs.find(function(input) {
            return !input.classList.contains('disabled');
          });

          if (firstAvailable && firstAvailable !== checkedInput) {
            firstAvailable.checked = true;
            didChange = true;
          }
        }
      });

      return didChange;
    }

    function initShopTheLookVariantSelects(sectionRoot) {
      if (!sectionRoot) return;

      sectionRoot.querySelectorAll('variant-selects.ec-shop-the-look__mobile-variants').forEach(function(variantSelects) {
        if (variantSelects.dataset.shopTheLookVariantsBound === 'true') return;
        variantSelects.dataset.shopTheLookVariantsBound = 'true';

        if (ensureAvailableVariantSelection(variantSelects)) {
          var checkedInput = variantSelects.querySelector('input[type="radio"]:checked');
          if (checkedInput) {
            checkedInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        variantSelects.addEventListener('change', function() {
          window.requestAnimationFrame(function() {
            if (!ensureAvailableVariantSelection(variantSelects)) return;

            var updatedChecked =
              variantSelects.querySelector('.product-form__input:last-child input[type="radio"]:checked') ||
              variantSelects.querySelector('input[type="radio"]:checked');

            if (updatedChecked) {
              updatedChecked.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        });
      });
    }

    function bindProductBuyButtons(sectionRoot) {
      var buyButtons = sectionRoot.querySelectorAll('.ec-shop-the-look__product-button');
      if (!buyButtons.length) return;

      buyButtons.forEach(function(button) {
        if (button.dataset.buyBound === 'true') return;
        button.dataset.buyBound = 'true';

        button.addEventListener('click', function(event) {
          if (!isMobileShopTheLook()) return;

          var productCard = button.closest('.ec-shop-the-look__product-card');
          var variantId = getBuyVariantId(productCard, button);

          if (!variantId) return;

          event.preventDefault();
          addProductToCart(variantId);
        });
      });
    }

    function initShopTheLook(sectionRoot) {
      if (!sectionRoot) return;

      var swiperContainer = sectionRoot.querySelector('.ec-shop-the-look .swiper');
      if (!swiperContainer || swiperContainer.dataset.swiperInitialized === 'true') {
        syncMobileProductCarousel(sectionRoot);
        initActiveSlideProduct(sectionRoot);
        placeCarouselPagination(sectionRoot);
        renderProductPagination(sectionRoot);
        updateProductArrowsState(sectionRoot);
        bindProductBuyButtons(sectionRoot);
        initShopTheLookVariantSelects(sectionRoot);
        updateSwiperNoSwiping(sectionRoot.__shopTheLookSwiper);
        return;
      }

      if (typeof Swiper === 'undefined') {
        window.addEventListener(
          'load',
          function() {
            initShopTheLook(sectionRoot);
          },
          { once: true }
        );
        return;
      }

      swiperContainer.dataset.swiperInitialized = 'true';

      var slides = swiperContainer.querySelectorAll('.swiper-slide');
      var slideCount = slides.length;

      var lookPaginationEl = sectionRoot.querySelector('.ec-shop-the-look__look-pagination');

      var swiper = new Swiper(swiperContainer, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        lazy: true,
        loop: slideCount > 1,
        noSwiping: isMobileShopTheLook(),
        noSwipingSelector: isMobileShopTheLook()
          ? '.ec-shop-the-look__products-zone, .ec-shop-the-look__products-zone *'
          : '',
        pagination: lookPaginationEl
          ? {
              el: lookPaginationEl,
              clickable: true,
            }
          : false,
      });

      sectionRoot.__shopTheLookSwiper = swiper;

      syncMobileProductCarousel(sectionRoot);
      initActiveSlideProduct(sectionRoot);
      bindProductArrows(sectionRoot);
      bindModelArrows(sectionRoot, swiper);
      bindProductBuyButtons(sectionRoot);
      initShopTheLookVariantSelects(sectionRoot);
      placeCarouselPagination(sectionRoot);
      renderProductPagination(sectionRoot);
      updateProductArrowsState(sectionRoot);
      updateSwiperNoSwiping(swiper);

      if (!sectionRoot.dataset.shopTheLookResizeBound) {
        sectionRoot.dataset.shopTheLookResizeBound = 'true';
        window.addEventListener('resize', function() {
          syncMobileProductCarousel(sectionRoot);
          updateSwiperNoSwiping(sectionRoot.__shopTheLookSwiper);
          if (!isMobileShopTheLook()) {
            bindProductArrows(sectionRoot);
            placeCarouselPagination(sectionRoot);
          }
          initActiveSlideProduct(sectionRoot);
          renderProductPagination(sectionRoot);
          updateProductArrowsState(sectionRoot);
        });
      }

      swiper.on('slideChange', function() {
        setTimeout(function() {
          syncMobileProductCarousel(sectionRoot);
          initActiveSlideProduct(sectionRoot);
          bindProductArrows(sectionRoot);
          bindModelArrows(sectionRoot, swiper);
          bindProductBuyButtons(sectionRoot);
        initShopTheLookVariantSelects(sectionRoot);
          placeCarouselPagination(sectionRoot);
          renderProductPagination(sectionRoot);
          updateProductArrowsState(sectionRoot);
          updateSwiperNoSwiping(swiper);
        }, 100);
      });

      swiper.on('slideChangeTransitionStart', function() {
        setProductNavSwitchingState(sectionRoot, true);
      });

      swiper.on('slideChangeTransitionEnd', function() {
        setProductNavSwitchingState(sectionRoot, false);
      });
    }

    function observeShopTheLook() {
      var sectionRoot = document.querySelector(sectionSelector);
      if (!sectionRoot) return;

      if (!('IntersectionObserver' in window)) {
        initShopTheLook(sectionRoot);
        return;
      }

      var observer = new IntersectionObserver(
        function(entries, currentObserver) {
          if (!entries.some(function(entry) { return entry.isIntersecting; })) return;
          currentObserver.disconnect();
          initShopTheLook(sectionRoot);
        },
        { rootMargin: '250px 0px' }
      );

      observer.observe(sectionRoot);
    }

    document.addEventListener('DOMContentLoaded', observeShopTheLook);
    document.addEventListener('shopify:section:load', function(event) {
      if (event.detail.sectionId === sectionId) {
        observeShopTheLook();
      }
    });
  })();
